import { FloatingPortal, useMergeRefs } from "@floating-ui/react";
import * as React from "react";
import { classNames } from "../../utils/classNames";
import { useTooltipContext } from "./TooltipContext";

export const TooltipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(function TooltipContent({ className, style, ...props }, propRef) {
  const context = useTooltipContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <FloatingPortal>
      <div
        ref={ref}
        style={{
          ...context.floatingStyles,
          ...style,
        }}
        className={classNames(
          "bg-primary text-primary shadow z-50",
          "rounded-lg",
          "text-xs/5 px-4 py-3",
          // Ensure the tooltip doesn't overflow the viewport, should be 100vw - 2 x the padding
          "max-w-[calc(100vw-(theme('spacing.4')*2))]",
          className,
        )}
        {...context.getFloatingProps(props)}
      />
    </FloatingPortal>
  );
});
